export default __webpack_public_path__ + "static/media/benefitsLeft.54a22d49.png";